export const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_glowmode-slc/artifacts/352e0b711e788fbd_0D6AAB11-70C1-49A2-B36D-80A77655B3EA.png";
export const PHONE = "(801) 828-6584";
export const PHONE_TEL = "tel:+18018286584";
export const EMAIL = "glowmodelighting@yahoo.com";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1505843513577-22bb7d21e455?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3VzZSUyMGR1c2slMjBhcmNoaXRlY3R1cmFsJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkyNTIxMjI5fDA&ixlib=rb-4.1.0&q=85",
  heroAlt: "https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob3VzZSUyMGR1c2slMjBhcmNoaXRlY3R1cmFsJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkyNTIxMjI5fDA&ixlib=rb-4.1.0&q=85",
  estate: "https://images.pexels.com/photos/4933643/pexels-photo-4933643.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  installer: "https://images.pexels.com/photos/8853474/pexels-photo-8853474.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  holidayTree: "https://images.unsplash.com/photo-1544397838-37a35169ebf0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxjaHJpc3RtYXMlMjBob3VzZSUyMG5pZ2h0JTIwbGlnaHRzJTIwaG9saWRheXxlbnwwfHx8fDE3OTI1MjEyMjl8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "permanent",
    name: "Permanent Trim Lighting",
    tag: "Year-round glow",
    desc: "Low-profile, app-controlled LED tracks mounted flush to your roofline. Change colors for game day, holidays, or a warm architectural wash every single night.",
    img: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBob3VzZSUyMGR1c2slMjBhcmNoaXRlY3R1cmFsJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkyNTIxMjI5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "holiday",
    name: "Holiday & Christmas Lighting",
    tag: "Our specialty",
    desc: "Custom-cut, commercial-grade displays designed for your home. Zero visible wires, free post-season takedown, and a price-beat guarantee every time.",
    img: "https://images.unsplash.com/photo-1576692155415-95f820a2c4c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxjaHJpc3RtYXMlMjBob3VzZSUyMG5pZ2h0JTIwbGlnaHRzJTIwaG9saWRheXxlbnwwfHx8fDE3OTI1MjEyMjl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "landscape",
    name: "Landscape & Patio Lighting",
    tag: "Outdoor living",
    desc: "Path lights, tree uplighting, bistro strands, and patio washes that turn your yard into the best room of the house after dark.",
    img: "https://images.unsplash.com/photo-1527359443443-84a48aec73d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxwYXRpbyUyMGxhbmRzY2FwZSUyMGdhcmRlbiUyMGxpZ2h0aW5nJTIwZHVza3xlbnwwfHx8fDE3OTI1MjEyMjl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "wedding",
    name: "Wedding & Event Lighting",
    tag: "Unforgettable nights",
    desc: "Fairy-light canopies, elegant warm washes, and full setup and teardown for weddings, receptions, and private events.",
    img: "https://images.pexels.com/photos/13326534/pexels-photo-13326534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "indoor",
    name: "Indoor Lighting",
    tag: "Interior ambiance",
    desc: "Accent, cove, and feature lighting that gives your interior spaces a warm, high-end finish.",
    img: "https://images.pexels.com/photos/13722826/pexels-photo-13722826.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "outdoor",
    name: "Outdoor Lighting",
    tag: "Curb appeal",
    desc: "Architectural washes and entry lighting that make your home look like a model home every night of the year.",
    img: "https://images.pexels.com/photos/4933643/pexels-photo-4933643.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "auto",
    name: "Automobile Lighting",
    tag: "Ride in glow mode",
    desc: "Custom interior ambient and accent lighting installs for cars, trucks, and show vehicles.",
    img: "https://images.unsplash.com/photo-1682858110563-3f609263d418?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxjYXIlMjBhbWJpZW50JTIwaW50ZXJpb3IlMjBsaWdodLighting%20led&ixlib=rb-4.1.0&q=85",
  },
];

export const BOOKING_TYPES = [
  "Holiday Lighting",
  "Permanent Trim Lighting",
  "Landscape & Patio Lighting",
  "Wedding & Event Lighting",
  "Indoor Lighting",
  "Outdoor Lighting",
  "Automobile Lighting",
  "Not Sure Yet",
];

export const GALLERY_SINGLES = [
  {
    id: "single-wedding-1",
    category: "wedding",
    title: "Enchanted Wedding String-Light Canopy",
    url: "https://images.pexels.com/photos/34597474/pexels-photo-34597474.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "single-wedding-2",
    category: "wedding",
    title: "Fairytale Fairy-Light Ceiling",
    url: "https://images.unsplash.com/photo-1539840516813-7e02c88f6fa4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwc3RyaW5nJTIwbGlnaHRzJTIwY2Fub3B5JTIwbmlnaHR8ZW58MHx8fDE3OTI1MjIxMTJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "single-indoor-1",
    category: "indoor",
    title: "Statement Chandelier & Cove Glow",
    url: "https://images.pexels.com/photos/19840855/pexels-photo-19840855.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "single-indoor-2",
    category: "indoor",
    title: "Modern Living Suite Accent Lighting",
    url: "https://images.unsplash.com/photo-1666585607888-3f6fe0b323d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MTJ8MHwxfHNlYXJjaHw0fHxpbmRvb3IlMjBsdXh1cnklMjBhbWJpZW50JTIwbGlnaHRpbmclMjBhcmNoaXRlY3R1cmFsfGVufDB8fHx8MTc5MjUyMjEyNHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "single-auto-1",
    category: "auto",
    title: "Luxury Auto Cabin Ambient LED",
    url: "https://images.unsplash.com/photo-1682858110563-3f609263d418?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxjYXIlMjBhbWJpZW50JTIwaW50ZXJpb3IlMjBsaWdodLighting%20led&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "single-treewrap-1",
    category: "treewrap",
    title: "Precision Trunk & Canopy Tree Wrap",
    url: "https://images.unsplash.com/photo-1481366574263-f643ed72bccc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHx0cmVlJTIwd3JhcHBlZCUyMGNocmlzdG1hcyUyMGxpZ2h0cyUyMG5pZ2h0fGVufDB8fHx8MTc5MjUyMjEyNHww&ixlib=rb-4.1.0&q=85",
  },
];

// Real GlowMode installs — photos provided by the owner. Add more as they come in.
export const GALLERY_OWN = [
  {
    id: "own-holiday-1",
    category: "holiday",
    title: "Festive Red & Green Roofline",
    url: "https://customer-assets-4nw71qhi.emergentagent.net/job_glowmode-slc/artifacts/df8926ff2e3eb7ce_image000000.jpeg",
  },
  {
    id: "own-holiday-2",
    category: "holiday",
    title: "Multicolor Peaks With Lit Wreaths",
    url: "https://customer-assets-4nw71qhi.emergentagent.net/job_glowmode-slc/artifacts/0f7345f4f9387d8c_IMG_0719.jpeg",
  },
  {
    id: "own-architectural-1",
    category: "architectural",
    title: "Full RGB Permanent Trim Install",
    url: "https://customer-assets-4nw71qhi.emergentagent.net/job_glowmode-slc/artifacts/d1c7c9183906d5c0_IMG_0750.jpeg",
  },
  {
    id: "own-landscape-1",
    category: "landscape",
    title: "Bistro String-Light Patio",
    url: "https://customer-assets-4nw71qhi.emergentagent.net/job_glowmode-slc/artifacts/596e2588b3037ffb_IMG_2220.jpeg",
  },
  {
    id: "own-landscape-2",
    category: "landscape",
    title: "Deck Rail & Post Lighting",
    url: "https://customer-assets-4nw71qhi.emergentagent.net/job_glowmode-slc/artifacts/2af5b9a0e7f1b661_Deck_Lighting_Omaha_NE_McKay_Landscape_Lighting_H__15.jpeg",
  },
];

export const GALLERY_FILTERS = [
  { id: "all", label: "All Work" },
  { id: "holiday", label: "Holiday" },
  { id: "architectural", label: "Permanent Trim" },
  { id: "landscape", label: "Landscape & Patio" },
  { id: "wedding", label: "Weddings & Events" },
  { id: "indoor", label: "Indoor" },
  { id: "auto", label: "Automobile" },
  { id: "treewrap", label: "Tree Wrapping" },
];
